module.exports = __webpack_public_path__ + "img/MT.6b788721.png";